import React, { Component } from 'react';
import Bounce from 'react-reveal/Bounce';
import Fade from 'react-reveal/Fade';


class Screen extends Component {
	render() {
		return (
			<div name="scroll-to-screen">
				<section className="is-fullheight section has-text-centered screen" id="screen" >
					<div className="container">
						<div className="content">
						<Fade left>
						<h2 className="title is-uppercase">Screen Apps</h2>
							<p className="subtitle">Lihat bagaimana aplikasi dibangun</p>
						</Fade>
						</div>
						<div className="columns is-multiline is-flex is-centered">
							<div className="column is-narrow-mobile">
								<Bounce left>
									<figure className="image">
										<img src="/img/screen/screen1.jpg" alt="" className="image_screen" />
									</figure>
								</Bounce>
							</div>
							<div className="column is-narrow-mobile">
								<Bounce left>
									<figure className="image">
										<img src="/img/screen/screen2.jpg" alt="" className="image_screen" />
									</figure>
								</Bounce>
							</div>
							<div className="column is-narrow-mobile">
								<Bounce left>
									<figure className="image">
										<img src="/img/screen/screen3.jpg" alt="" className="image_screen" />
									</figure>
								</Bounce>
							</div>
							<div className="column is-narrow-mobile">
								<Bounce left>
									<figure className="image">
										<img src="/img/screen/screen4.jpg" alt="" className="image_screen" />
									</figure>
								</Bounce>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default Screen;
